<template>
  <div class="main-content">
    <!-- 列表页 -->
    <div v-if="showFlag">
      <el-form :inline="true" :model="searchForm">
        <el-row :gutter="20">
          <el-form-item :label="$t('userManagement.account')">
            <el-input v-model="searchForm.zhanghao" :placeholder="$t('userManagement.account')" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('userManagement.name')">
            <el-input v-model="searchForm.xingming" :placeholder="$t('userManagement.name')" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">
              <i class="el-icon-search"></i>{{ $t('common.search') }}
            </el-button>
          </el-form-item>
        </el-row>
        <!-- 操作按钮行 -->
        <el-row class="ad">
          <el-form-item>
            <el-button type="success" @click="addOrUpdateHandler()">
              <i class="el-icon-plus"></i>{{ $t('common.add') }}
            </el-button>
            <el-button 
              type="danger" 
              :disabled="dataListSelections.length <= 0"
              @click="deleteHandler()"
            >
              <i class="el-icon-delete"></i>{{ $t('common.delete') }}
            </el-button>
            <!-- 新增导入/导出按钮 -->
            <el-button type="warning" @click="downloadTemplate">
              <i class="el-icon-download"></i>{{ $t('common.downloadTemplate') }}
            </el-button>
            <el-upload
              ref="importUpload"
              class="upload-demo"
              style="display: inline-block; margin-left: 10px;"
              :action="importUrl"
              :headers="getUploadHeaders()"
              :on-success="handleImportSuccess"
              :on-error="handleImportError"
              :before-upload="beforeImportUpload"
              :show-file-list="false"
              accept=".xlsx,.xls,.csv"
            >
              <el-button type="info">
                <i class="el-icon-upload2"></i>{{ $t('common.importFile') }}
              </el-button>
            </el-upload>
            <el-button  style="display: inline-block; margin-left: 10px;" type="primary" @click="exportExcel" :loading="exportLoading">
              <i class="el-icon-s-promotion"></i>{{ $t('common.exportCsv') }}
            </el-button>
          </el-form-item>
        </el-row>
      </el-form>

      <!-- 数据表格 -->
      <div class="table-content">
        <el-table :data="dataList" v-loading="dataListLoading" @selection-change="selectionChangeHandler">
          <el-table-column v-if="contents.tableSelection" type="selection" width="55"></el-table-column>
          <el-table-column v-if="contents.tableIndex" type="index" :label="$t('common.serialNumber')" width="60"></el-table-column>
          
          <el-table-column prop="zhanghao" :label="$t('userManagement.account')"></el-table-column>
          <el-table-column prop="xingming" :label="$t('userManagement.name')"></el-table-column>
          <el-table-column prop="xingbie" :label="$t('userManagement.gender')"></el-table-column>
          <el-table-column prop="shouji" :label="$t('userManagement.phone')"></el-table-column>
          <el-table-column prop="dizhi" :label="$t('userManagement.address')"></el-table-column>
          <el-table-column prop="yue" :label="$t('userManagement.balance')">
            <template slot-scope="scope">
              {{ scope.row.yue | formatCurrency }}
            </template>
          </el-table-column>
          <el-table-column prop="jifen" :label="$t('userManagement.points')"></el-table-column>
          <el-table-column prop="addtime" :label="$t('common.addTime')"></el-table-column>
          
          <!-- 新增列 -->
          <el-table-column prop="appointmentCount" :label="$t('userManagement.totalAppointments')"></el-table-column>
          <el-table-column prop="lastAppointmentTime" :label="$t('userManagement.lastAppointmentTime')"></el-table-column>
          <el-table-column prop="technicians" :label="$t('userManagement.allTechnicians')"></el-table-column>
          <el-table-column prop="totalConsumption" :label="$t('userManagement.totalConsumption')">
            <template slot-scope="scope">
              {{ scope.row.totalConsumption | formatCurrency }}
            </template>
          </el-table-column>
          <el-table-column prop="lastProjectId" :label="$t('userManagement.lastProjectId')"></el-table-column>
          
          <el-table-column :label="$t('common.operation')" width="220">
            <template slot-scope="scope">
              <el-button type="info" size="mini" @click="addOrUpdateHandler(scope.row.id, 'info')">{{ $t('common.detail') }}</el-button>
              <el-button type="primary" size="mini" @click="addOrUpdateHandler(scope.row.id)">{{ $t('common.edit') }}</el-button>
              <el-button type="danger" size="mini" @click="deleteHandler(scope.row.id)">{{ $t('common.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="totalPage"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
        ></el-pagination>
      </div>
    </div>

    <!-- 添加/修改弹窗 -->
    <add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from './add-or-update'
import storage from '@/utils/storage'

export default {
  components: { AddOrUpdate },
  data() {
    return {
      searchForm: { zhanghao: '', xingming: '' },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      addOrUpdateFlag: false,
      // 简单配置，仅保留必需项
      contents: {
        tableSelection: true,
        tableIndex: true,
        pageEachNum: 10
      },
      // 导入/导出相关
      exportLoading: false,
      importUrl: '/springboot6hv37/yonghu/import',
      uploadHeaders: {
        'token': storage.get('Token') || ''
      },
      // 导入对话框
      importDialogVisible: false,
      importFileList: []
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取用户数据并统计预约信息
    // getDataList() {
    //   this.dataListLoading = true;
    //   const params = {
    //     page: this.pageIndex,
    //     limit: this.pageSize,
    //     sort: "id",
    //     zhanghao: this.searchForm.zhanghao ? "%" + this.searchForm.zhanghao + "%" : undefined,
    //     xingming: this.searchForm.xingming ? "%" + this.searchForm.xingming + "%" : undefined
    //   };
    //   // 获取用户列表
    //   this.$http({
    //     url: "yonghu/list",
    //     method: "get",
    //     params
    //   }).then(({ data }) => {
    //     if (data && data.code === 0) {
    //       const users = data.data.list;
    //       this.totalPage = data.data.total;
    //       // 获取教练预约数据
    //       this.$http({
    //         url: "jiaolianyuyue/list",
    //         method: "get"
    //       }).then(({ data: appointmentRes }) => {
    //         console.log("appointmentRes",appointmentRes);
            
    //         let appointments = [];
    //         if (appointmentRes && appointmentRes.code === 0) {
    //           appointments = appointmentRes.data.list || [];
    //         }
    //         // 对每个用户按账号(zhanghao)关联预约数据并统计
    //         users.forEach(user => {
    //           const userAppts = appointments.filter(appt => appt.zhanghao === user.zhanghao);
    //           user.appointmentCount = userAppts.length;
    //           if (userAppts.length) {
    //             // 取最近预约记录（假设start_time为可比较字符串或日期格式）
    //             userAppts.sort((a, b) => new Date(b.start_time) - new Date(a.start_time));
    //             user.lastAppointmentTime = userAppts[0].start_time;
    //             user.lastProjectId = userAppts[0].project_id;
    //             user.totalConsumption = userAppts.reduce((sum, appt) => sum + (appt.price || 0), 0);
    //             // 汇总所有预约技师信息（去重）
    //             const techSet = new Set();
    //             userAppts.forEach(appt => {
    //               techSet.add(`${appt.jiaolianbianhao} ${appt.jiaolianxingming}`);
    //             });
    //             user.technicians = Array.from(techSet).join(', ');
    //           } else {
    //             user.lastAppointmentTime = '';
    //             user.lastProjectId = '';
    //             user.totalConsumption = 0;
    //             user.technicians = '';
    //           }
    //         });
    //         this.dataList = users;
    //         this.dataListLoading = false;
    //       });
    //     } else {
    //       this.dataList = [];
    //       this.totalPage = 0;
    //       this.dataListLoading = false;
    //     }
    //   });
    // },
    // 获取数据列表及统计预约数据（修改后的部分）
getDataList() {
  this.dataListLoading = true;
  const params = {
    page: this.pageIndex,
    limit: this.pageSize,
    sort: "id",
    zhanghao: this.searchForm.zhanghao ? "%" + this.searchForm.zhanghao + "%" : undefined,
    xingming: this.searchForm.xingming ? "%" + this.searchForm.xingming + "%" : undefined
  };
  // 获取用户列表
  this.$http({
    url: "yonghu/list",
    method: "get",
    params
  }).then(({ data }) => {
    if (data && data.code === 0) {
      const users = data.data.list;
      this.totalPage = data.data.total;
      // 请求所有教练预约数据：使用 limit 参数设置为足够大（例如9999）
      this.$http({
        url: "jiaolianyuyue/list",
        method: "get",
        params: { page: 1, limit: 9999 }
      }).then(({ data: appointmentRes }) => {
        let appointments = [];
        if (appointmentRes && appointmentRes.code === 0) {
          appointments = appointmentRes.data.list || [];
        }
        // 对每个用户按账号(zhanghao)关联预约数据并统计
        users.forEach(user => {
          const userAppts = appointments.filter(appt => appt.zhanghao === user.zhanghao);
          user.appointmentCount = userAppts.length;
          if (userAppts.length) {
            console.log("userAppts",userAppts);
            
            // 取最近预约记录（假设start_time为可比较字符串或日期格式）
            // userAppts.sort((a, b) => new Date(b.start_time) - new Date(a.start_time));
            user.lastAppointmentTime = userAppts[userAppts.length-1].startTime;
            user.lastProjectId = userAppts[userAppts.length-1].projectId;
            user.totalConsumption = userAppts.reduce((sum, appt) => sum + (appt.price || 0), 0);
            // 汇总所有预约技师信息（去重）
            const techSet = new Set();
            userAppts.forEach(appt => {
              techSet.add(`${appt.jiaolianbianhao} ${appt.jiaolianxingming}`);
            });
            user.technicians = Array.from(techSet).join(', ');
          } else {
            user.lastAppointmentTime = '';
            user.lastProjectId = '';
            user.totalConsumption = 0;
            user.technicians = '';
          }
        });
        this.dataList = users;
        this.dataListLoading = false;
      });
    } else {
      this.dataList = [];
      this.totalPage = 0;
      this.dataListLoading = false;
    }
  });
},

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    addOrUpdateHandler(id, type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, type === "info" ? "info" : "else");
      });
    },
    deleteHandler(id) {
      const ids = id ? [Number(id)] : this.dataListSelections.map(item => Number(item.id));
      this.$confirm(`确定进行${id ? "删除" : "批量删除"}操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "yonghu/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    // 表头样式（可根据需要调整）
    headerRowStyle() {
      return {};
    },
    headerCellStyle() {
      return {};
    },
    download(file) {
      window.open(file);
    },
    
    // 获取上传请求头
    getUploadHeaders() {
      return {
        'token': storage.get('Token') || ''
      };
    },
    // 导出Excel
    exportExcel() {
      this.exportLoading = true;
      
      // 获取所有用户数据用于导出
      this.$http({
        url: "yonghu/page",
        method: "get",
        params: {
          page: 1,
          limit: 10000, // 获取所有数据
          sort: "id"
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          const users = data.data.list;
          
          // 获取所有预约数据用于统计
          this.$http({
            url: "jiaolianyuyue/page",
            method: "get",
            params: { page: 1, limit: 10000 }
          }).then(({ data: appointmentRes }) => {
            let appointments = [];
            if (appointmentRes && appointmentRes.code === 0) {
              appointments = appointmentRes.data.list || [];
            }
            
            // 处理数据并添加预约统计
            const exportData = users.map(user => {
              const userAppts = appointments.filter(appt => appt.zhanghao === user.zhanghao);
              
              // 计算统计数据
              const appointmentCount = userAppts.length;
              const totalConsumption = userAppts.reduce((sum, appt) => sum + (appt.price || 0), 0);
              
              // 获取最近预约信息
              let lastAppointmentTime = '';
              let lastProjectId = '';
              let technicians = '';
              
              if (userAppts.length > 0) {
                lastAppointmentTime = userAppts[userAppts.length - 1].startTime || '';
                lastProjectId = userAppts[userAppts.length - 1].projectId || '';
                
                // 汇总所有预约技师（去重）
                const techSet = new Set();
                userAppts.forEach(appt => {
                  if (appt.jiaolianbianhao && appt.jiaolianxingming) {
                    techSet.add(`${appt.jiaolianbianhao} ${appt.jiaolianxingming}`);
                  }
                });
                technicians = Array.from(techSet).join(', ');
              }
              
              return {
                账号: user.zhanghao || '',
                姓名: user.xingming || '',
                性别: user.xingbie || '',
                手机: user.shouji || '',
                地址: user.dizhi || '',
                余额: user.yue || 0,
                积分: user.jifen || 0,
                添加时间: user.addtime || '',
                总预约次数: appointmentCount,
                最后预约时间: lastAppointmentTime,
                所有预约技师: technicians,
                总消费金额: totalConsumption,
                最后服务项目ID: lastProjectId
              };
            });
            
            // 使用CSV导出
            this.downloadCSV(exportData, `用户列表_${new Date().toISOString().slice(0, 10)}.csv`);
            this.exportLoading = false;
            this.$message.success('导出成功');
          });
        } else {
          this.exportLoading = false;
          this.$message.error('获取数据失败');
        }
      }).catch(() => {
        this.exportLoading = false;
        this.$message.error('导出失败');
      });
    },
    
    // CSV导出方法
    downloadCSV(data, filename) {
      if (!data || !data.length) {
        this.$message.warning('没有数据可导出');
        return;
      }
      
      // 获取表头
      const headers = Object.keys(data[0]);
      
      // 构建CSV内容
      let csvContent = '\uFEFF'; // BOM for UTF-8
      csvContent += headers.join(',') + '\n';
      
      data.forEach(row => {
        const values = headers.map(header => {
          let value = row[header] || '';
          // 处理包含逗号、引号或换行符的值
          if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
            value = '"' + value.replace(/"/g, '""') + '"';
          }
          return value;
        });
        csvContent += values.join(',') + '\n';
      });
      
      // 创建下载链接
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    
    // 格式化导出数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    
    // 下载导入模板
    downloadTemplate() {
      // 创建Excel格式的模板数据
      const templateData = [
        ['账号', '姓名', '性别', '手机', '地址', '余额', '积分', '密码'],
        ['user001', '张三', '男', '13800138000', '北京市朝阳区', '1000', '100', '123456'],
        ['user002', '李四', '女', '13800138001', '上海市浦东区', '2000', '200', '123456']
      ];
      
      // 创建CSV内容
      let csvContent = '\uFEFF'; // BOM for UTF-8
      templateData.forEach(row => {
        csvContent += row.join(',') + '\n';
      });
      
      // 下载文件
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', '用户导入模板.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.$message.success('模板下载成功');
    },
    
    // 导入前的验证
    beforeImportUpload(file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                     file.type === 'application/vnd.ms-excel';
      const isCSV = file.type === 'text/csv' || file.type === 'application/csv' || 
                   file.name.toLowerCase().endsWith('.csv');
      const isLt10M = file.size / 1024 / 1024 < 10;
      
      if (!isExcel && !isCSV) {
        this.$message.error('只能上传Excel文件(.xlsx, .xls)或CSV文件(.csv)');
        return false;
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB');
        return false;
      }
      
      this.$message.info('正在导入，请稍候...');
      return true;
    },
    
    // 导入成功回调
    handleImportSuccess(response, file, fileList) {
      if (response && response.code === 0) {
        this.$message.success(`导入成功: ${response.msg || '已成功导入用户数据'}`);
        this.getDataList(); // 刷新列表
      } else {
        this.$message.error(`导入失败: ${response.msg || '请检查文件格式'}`);
      }
    },
    
    // 导入失败回调
    handleImportError(err, file, fileList) {
      console.error('Import error:', err);
      this.$message.error('文件导入失败，请检查文件格式或网络连接');
    }
  }
}
</script>
